import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { productKeyAtom } from "src/atoms";
import { isTest, ProductKey } from "src/config/config";
export const useRouter = () => {
  const router = useNavigate();
  const params = useParams();
  const pathname = window.location.pathname.substring(3);
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  const search = window.location.search;
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return {
    router: router,
    currentPath: window.location.pathname,
    reload: () => window.location.reload(),
    lang,
    productReload: ({
      productKey,
      urlPrefix,
    }: {
      productKey: ProductKey;
      urlPrefix?: string;
    }) => {
      if (productKey === "WRAPSODY") {
        console.log("wrapsody reload")
        return (window.parent.location.href =
          "https://cloud.wrapsody.com/filesync/ui/reload");
        }
      else if (productKey === "WRAPSODY_ECO") {
        console.log("eco reload")
        return (window.parent.location.href = `https://cloud.wrapsodyeco.com/${urlPrefix}/home`);
      }
    },
    params: params,
    parentRouteTo: ({
      path,
      isReload = false,
    }: {
      path: string;
      isReload?: boolean;
    }) => {
      if (isReload) {
        window.parent.location.reload();
      } else window.parent.location.href = path;
    },
    routeTo: (path: string) => router(path),
    changeLang: () => {
      const changeLang = lang === "ko" ? "en" : "ko";
      i18n.changeLanguage(changeLang);
      router(`/${changeLang}${pathname}${search}`);
      goToTop();
    },
    goHome: () => {
      router(`/${lang}`);
      setProductKey(undefined);
    },
    goLogin: () => {
      router(`/${lang}/login`);
      goToTop();
    },
    goJoin: () => {
      router(`/${lang}/join`);
      goToTop();
    },
    goConsole: () => {
      router(`/${lang}/console`);
      goToTop();
    },
    goBill: () => {
      router(`/${lang}/bill`);
      goToTop();
    },
    goMyAccount: () => router(`/${lang}/my-account`),
    goTest: () => router(`/${lang}/test`),

    // site
    goSiteType: () => {
      router(`/${lang}/site/type`);
      goToTop();
    },
    goSiteTrial: () => {
      router(`/${lang}/site/trial`);
      goToTop();
    },
    goSitePromotion: ({
      renewCode,
      type,
    }: {
      renewCode?: string;
      type?: string;
    }) => {
      if (type) {
        if (renewCode) {
          router(`/${lang}/site/promotion?type=${type}&code=${renewCode}`);
        } else {
          router(`/${lang}/site/promotion?type=${type}`);
        }
      } else if (renewCode) {
        router(`/${lang}/site/promotion?type=renew&code=${renewCode}`);
      } else router(`/${lang}/site/promotion`);
      goToTop();
    },
    goPay: ({ pay = "month", type }: { pay?: string; type: string }) => {
      // console.log("goPay", pay, type);
      router(`/${lang}/site/pay?pay=${pay}&type=${type}`);
      goToTop();
    },
    goPayBasic: () => {
      router(`/${lang}/site/pay?pay=month&type=basic`);
      goToTop();
    },
    goPayPlus: () => {
      router(`/${lang}/site/pay?pay=month&type=plus`);
      goToTop();
    },
    // Footer 아이콘
    goToBlog: () => window.open(`https://blog.naver.com/fs0608`),
    goToYoutube: () => {
      if (lang === "ko") {
        window.open(`https://www.youtube.com/user/FasooMarcom`);
      } else if (lang === "en") {
        window.open(`https://www.youtube.com/user/FasooMarketing`);
      }
    },
    goToFacebook: () => {
      if (lang === "ko") {
        window.open(`https://ko-kr.facebook.com/fasoo.korea/`);
      } else if (lang === "en") {
        window.open(`https://www.facebook.com/fasoo.global`);
      }
    },
    goToInsta: () => {
      if (lang === "ko") {
        window.open(`https://www.instagram.com/fasoo_official/`);
      } else if (lang === "en") {
        window.open(`https://www.instagram.com/fasoo_global/`);
      }
    },
    openWrapsody: () => {
      window.open(`https://cloud.wrapsody.com`);
    },
    openEco: ({ domainName }: { domainName: string }) => {
      window.open(`https://${domainName}`);
    },
    openMindSat: ({ domainName }: { domainName: string }) => {
      if (isTest) {
        window.open(`http://146.56.156.112/secure-mind-sat-admin`);
      } else {
        window.open(`https://${domainName}`);
      }
    },
    goTerms: () => {
      router(`/${lang}/terms`);
      goToTop();
    },
    goInquiry: ({ product }: { product: "wrapsody" | "eco" }) => {
      router(`/${lang}/inquiry/dspm`);
      goToTop();
    },
  };
  function goToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
